export default __webpack_public_path__ + "static/media/keralab-logo.9c93194f.svg";